import { Component, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { HeaderComponent } from '../../atoms/header/header.component';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [DialogModule, Button, HeaderComponent, DividerModule],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
})
export class CookieConsentComponent implements OnInit {
  displayDialog = false; // Bool flag to toggle p-dialog visibility

  private readonly COOKIE_NAME = 'hyperion-cookie-consent';
  ngOnInit(): void {
    this.displayDialog = !this.hasCookieConsent();
  }

  /**
   * Checks if the user has given consent for cookies.
   *
   * This method verifies whether cookie consent has been granted by checking
   * either the presence of a specific cookie or the existence of a corresponding
   * entry in localStorage.
   *
   * @return {boolean} Returns true if cookie consent has been granted, otherwise false.
   */
  hasCookieConsent(): boolean {
    return (
      document.cookie.includes(`${this.COOKIE_NAME}=true`) ||
      localStorage.getItem(this.COOKIE_NAME) === 'true'
    );
  }

  /**
   * Stores user consent in a cookie and optionally hides the consent dialog.
   * The cookie is valid for 1 year.
   *
   * @return {void} Does not return a value.
   */
  giveConsent(): void {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${this.COOKIE_NAME}=true; expires=${expiryDate.toUTCString()}; path=/`;
    this.displayDialog = false;
  }
}
